import React from "react";
import { Col, Skeleton } from "antd";

const BoxLoading = ({ width, height = 100, col = 12 , xs, borderRadius = 8, styles }) => {
  return (
    <Col md={col} xs={xs}>
      <Skeleton.Button
        active
        style={{
          ...styles,
          height,
          borderRadius,
          width,
        }}
        block
      />
    </Col>
  );
};

export default BoxLoading;
